import BatchHistoryColumn from './BatchHistoryColumn';
import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import DeleteFilterTable from '../../microComponents/tablePages/filter/DeleteFilterTable';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import React from "react";
import ShowSearchBtn from "../../microComponents/tablePages/ShowSearchBtn";
import CollapseBox from "../../microComponents/tablePages/CollapseBox";
import {useSelector} from "react-redux";
import TopSearchBatchHistory from "./TopSearchBatchHistory";
import ExpandedBatchHistory from "./ExpandedBatchHistory";
import {useNavigate} from "react-router-dom";


const BatchHistory = () => {
    const showSearchBox = useSelector((state) => state.TableRedux.showSearchBox);
    const navigate = useNavigate();

    const [columns] = BatchHistoryColumn();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>تاریخچه بچ</Title>
                    <div className='flex gap-2 items-center'>

                        <DeleteFilterTable/>
                        <ShowSearchBtn/>
                    </div>
                </div>
                <div className='searchBox p-0'>
                    <CollapseBox activeKey={showSearchBox ? ['1'] : null} items={[{
                        showArrow: false, headerPadding: '1px', className: 'bg-white border-none',
                        key: '1', children: <TopSearchBatchHistory/>,
                    }]}/>

                </div>
            </ComponentCard> <ComponentCard>

            <CreatorTable


                columns={columns} listAddress='Batch'
                expandable={{
                    expandedRowRender: (row) => (

                        <ExpandedBatchHistory item={row}/>

                    ),
                    // rowExpandable: (record) => record.name !== 'Not Expandable',
                }}
                onDoubleClickRowHandler={(row) => {
                    navigate(`/PalletStatus?batchNumber=${row.batchNumber}`);
                }}
                rowClassName={(record) => (record.status && "tableRowBgGreen")}/>


        </ComponentCard></div>
    );
};


export default BatchHistory;